import { Outlet } from 'react-router-dom';
import Nav from '../common/Nav/Nav';
import MainLayoutWrapper from './MainLayoutWrapper/MainLayoutWrapper';
import { NavigationProvider } from '../../providers/NavigationProvider';
import { TourProvider } from '@reactour/tour';
import ConfirmationModalContextProvider from '../../providers/ConfirmModalProvider';
import TopBar from '../TopBar/TopBar';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material';

const MainLayout = () => {
  const theme = useTheme();
  return (
    <TourProvider
      disableInteraction={true}
      scrollSmooth={true}
      steps={[]}
      styles={{
        popover: (base) => ({
          ...base,
          "--reactour-accent": theme.colors.primary,
          borderRadius: 10
        })
      }}>
      <NavigationProvider>
        <ConfirmationModalContextProvider>
          {/* https://www.npmjs.com/package/@reactour/tour */}
          <Stack direction="row">
            <Nav />
            <Stack direction="column" width="100%">
              <TopBar />
              <MainLayoutWrapper>
                <Outlet />
              </MainLayoutWrapper>
            </Stack>
          </Stack>
        </ConfirmationModalContextProvider>
      </NavigationProvider>
    </TourProvider>
  );
};

export default MainLayout;
